import type { IkeActionOrgSearch } from '@ikegps/core-api';
import { type IkeClientService, Services } from '.';

export class SearchOrgService implements IkeClientService {
	__priority: number = 50;

	private query = { text: 'test' };

	async sendQuery(str: string) {
		this.query.text = str;
		const rest = Services.Department.rest;
		return (await rest.action<IkeActionOrgSearch>('org.search', this.query)).results;
	}
}
